var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdv5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 60,
    viewBox: "0 0 97 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_100754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100586 28.1669C0.100586 26.7112 1.06708 25.2554 3.00008 24.1447L41.5001 2.02223C45.366 -0.199162 51.6341 -0.199202 55.5001 2.02223L94 24.1447C95.933 25.2554 96.899 26.7111 96.899 28.1669V32.1892C96.899 30.7334 95.933 29.2776 94 28.1669L55.5001 6.04449C51.6341 3.82306 45.366 3.8231 41.5001 6.04449L3.00008 28.1669C1.06708 29.2776 0.100586 30.7334 0.100586 32.1892V28.1669Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_696_100754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.899 28.1671C96.899 29.6229 95.933 31.0787 94 32.1894L55.5001 54.3118C51.6341 56.5333 45.366 56.5332 41.5001 54.3118L3.00008 32.1894C1.06708 31.0787 0.100586 29.6229 0.100586 28.1671V32.1894C0.100586 33.6451 1.06708 35.1009 3.00008 36.2116L41.5001 58.3341C45.366 60.5555 51.6341 60.5555 55.5001 58.3341L94 36.2116C95.933 35.1009 96.899 33.6452 96.899 32.1894V28.1671Z",
    fill: "url(#paint0_linear_696_100754)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6671 2.12778L3.18368 24.2407C-0.590133 26.4091 -0.590133 29.9249 3.18368 32.0934L41.6671 54.2063C45.4409 56.3747 51.5595 56.3747 55.3333 54.2063L93.8167 32.0934C97.5905 29.9249 97.5905 26.4091 93.8167 24.2407L55.3333 2.12778C51.5595 -0.040689 45.4409 -0.0406878 41.6671 2.12778Z",
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.404145
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4369 21.1635L38.2036 26.4691C36.9288 27.2016 36.922 28.3854 38.1884 29.1131L47.3609 34.3837C48.6274 35.1114 50.6875 35.1075 51.9624 34.375L61.1957 29.0694C62.4706 28.3369 62.4774 27.1531 61.2109 26.4254L52.0384 21.1548C50.7719 20.4271 48.7118 20.431 47.4369 21.1635ZM35.9105 25.1514C33.3608 26.6165 33.3472 28.9841 35.8801 30.4395L45.0526 35.7101C47.5855 37.1655 51.7058 37.1577 54.2555 35.6926L63.4888 30.3871C66.0386 28.922 66.0522 26.5544 63.5193 25.099L54.3467 19.8284C51.8138 18.373 47.6935 18.3808 45.1438 19.8459L35.9105 25.1514Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6408 15.2625C50.4707 15.3603 50.2715 15.4102 50.0432 15.4124C49.8227 15.4101 49.6338 15.3638 49.4767 15.2735C49.3121 15.1789 49.2315 15.0704 49.235 14.948L48.8033 10.9135C48.7734 10.6297 48.7044 10.3856 48.5962 10.1812C48.4957 9.97241 48.3407 9.80771 48.1311 9.68731C47.8019 9.49821 47.4595 9.36811 47.1041 9.29721C46.7486 9.22621 46.399 9.21641 46.0552 9.26781C45.704 9.31481 45.3775 9.42501 45.0759 9.59831C44.782 9.76721 44.59 9.96351 44.4999 10.1873C44.41 10.4023 44.419 10.6208 44.5267 10.8426C44.6347 11.0558 44.8346 11.2462 45.1264 11.4139C45.276 11.4999 45.349 11.6085 45.3452 11.7396C45.3492 11.8663 45.2661 11.9786 45.0959 12.0764C44.9335 12.1697 44.7382 12.2174 44.5099 12.2196C44.2817 12.2218 44.0927 12.1799 43.9431 12.0939C43.4342 11.8015 43.1014 11.4725 42.9445 11.1068C42.7802 10.7368 42.787 10.3674 42.965 9.99861C43.1506 9.62531 43.5026 9.28981 44.0208 8.99211C44.5467 8.68991 45.1115 8.49001 45.7152 8.39251C46.319 8.29501 46.9235 8.30021 47.529 8.40811C48.1421 8.51151 48.7218 8.72021 49.2681 9.03411C49.5075 9.17161 49.6966 9.34251 49.8352 9.54661C49.9816 9.74631 50.0859 9.95731 50.1479 10.1796C50.2177 10.3975 50.2612 10.6047 50.2784 10.8012L50.54 14.0047L53.7884 12.1381C53.9586 12.0404 54.1615 11.9925 54.3973 11.9947C54.6255 11.9925 54.8145 12.0344 54.9641 12.1204C55.1213 12.2107 55.198 12.3214 55.1942 12.4526C55.1904 12.5838 55.1035 12.6982 54.9333 12.796L50.6408 15.2625Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.034 15.6797C49.692 15.6762 49.3888 15.6014 49.1474 15.4627C48.9076 15.325 48.7693 15.1527 48.7696 14.9556L48.3388 10.9303C48.3105 10.661 48.2457 10.4384 48.1509 10.2594L48.1475 10.2528C48.0627 10.0766 47.9411 9.95661 47.8018 9.87651C47.5106 9.70921 47.2261 9.60471 46.9507 9.54971C46.6765 9.49501 46.4208 9.48931 46.1715 9.52651L46.1601 9.52821C45.9079 9.56201 45.656 9.64271 45.4045 9.78721C45.1698 9.92211 45.0227 10.0742 44.9531 10.2472L44.9522 10.2493C44.8818 10.4177 44.8873 10.5895 44.974 10.769C45.0588 10.9355 45.2157 11.0869 45.4555 11.2247C45.6997 11.365 45.8142 11.5436 45.8104 11.7391C45.8146 11.9434 45.6734 12.1223 45.4246 12.2653C45.1771 12.4074 44.8666 12.4836 44.5168 12.4869L44.5098 12.2196C44.7381 12.2174 44.9334 12.1697 45.0958 12.0764C45.266 11.9786 45.3491 11.8663 45.3451 11.7396C45.3489 11.6085 45.2759 11.4999 45.1263 11.4139C44.8345 11.2462 44.6346 11.0558 44.5266 10.8426C44.4189 10.6208 44.4099 10.4023 44.4998 10.1873C44.5899 9.96351 44.7819 9.76721 45.0758 9.59831C45.3774 9.42501 45.7039 9.31481 46.0551 9.26781C46.3989 9.21641 46.7485 9.22621 47.104 9.29721C47.4594 9.36811 47.8018 9.49821 48.131 9.68731C48.3406 9.80771 48.4956 9.97241 48.5961 10.1812C48.7043 10.3856 48.7733 10.6297 48.8032 10.9135L49.2349 14.948C49.2314 15.0704 49.312 15.1789 49.4766 15.2735C49.6337 15.3638 49.8226 15.4101 50.0431 15.4124C50.2714 15.4102 50.4706 15.3603 50.6407 15.2625L54.9332 12.796C55.1034 12.6982 55.1903 12.5838 55.1941 12.4526C55.1979 12.3214 55.1212 12.2107 54.964 12.1204C54.8144 12.0344 54.6254 11.9925 54.3972 11.9947C54.1614 11.9925 53.9585 12.0404 53.7883 12.1381L50.5399 14.0047L50.2783 10.8012C50.2611 10.6047 50.2176 10.3975 50.1478 10.1796C50.0858 9.95731 49.9815 9.74631 49.8351 9.54661C49.6965 9.34251 49.5074 9.17161 49.268 9.03411C48.7217 8.72021 48.142 8.51151 47.5289 8.40811C46.9234 8.30021 46.3189 8.29501 45.7151 8.39251C45.1114 8.49001 44.5466 8.68991 44.0207 8.99211C43.5025 9.28981 43.1505 9.62531 42.9649 9.99861C42.7869 10.3674 42.7801 10.7368 42.9444 11.1068C43.1013 11.4725 43.4341 11.8015 43.943 12.0939C44.0926 12.1799 44.2816 12.2218 44.5098 12.2196L44.5168 12.4869C44.1735 12.4902 43.8597 12.4244 43.6137 12.283C43.0516 11.96 42.6724 11.5893 42.4931 11.1722C42.3092 10.7574 42.3171 10.3409 42.5165 9.92761L42.5175 9.92551C42.7268 9.50481 43.1226 9.13031 43.6919 8.80321C44.2639 8.47451 44.8961 8.24721 45.5899 8.13511C46.28 8.02371 46.975 8.02971 47.664 8.15211C48.3646 8.27071 49.0084 8.50651 49.5972 8.84491C49.8861 9.01081 50.1074 9.21301 50.2663 9.44571C50.4258 9.66391 50.5389 9.89351 50.6064 10.1338C50.6789 10.3607 50.7247 10.5787 50.743 10.7874L50.9554 13.3882L53.4596 11.9492C53.7152 11.8024 54.0362 11.7251 54.3977 11.7273C54.7381 11.7251 55.049 11.7909 55.2933 11.9312C55.542 12.0741 55.6651 12.2552 55.6593 12.4566C55.6534 12.6612 55.5126 12.8409 55.262 12.9849L50.9695 15.4514C50.7188 15.5954 50.4061 15.6763 50.0501 15.6797H50.034Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8564 24.595C46.3503 24.4781 46.9199 24.5441 47.2994 24.7622L54.6414 28.981C55.1597 29.2788 55.1621 29.7603 54.6468 30.0564C54.1315 30.3525 53.2936 30.3511 52.7753 30.0533L47.699 27.1364L47.7027 27.8721C47.7048 28.2921 47.1141 28.6316 46.3832 28.6304C45.6523 28.6291 45.0581 28.2877 45.056 27.8677L45.043 25.2962C45.0415 24.9886 45.3625 24.7119 45.8564 24.595Z",
    fill: "#3399CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_696_100754",
    x: 0.100586,
    y: 28.1671,
    width: 96.7983,
    height: 34.2579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_696_100754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42487
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_696_100754",
    result: "effect2_innerShadow_696_100754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.04145
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_696_100754",
    result: "effect3_innerShadow_696_100754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_100754",
    x1: 0.100586,
    y1: 28.1671,
    x2: 24.9289,
    y2: 88.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AED6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_100754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv5);
export default __webpack_public_path__ + "static/media/adv-5.94fabd4c755d18abd3e7fe5a38351633.svg";
export { ForwardRef as ReactComponent };